import { put, call, fork, take } from 'redux-saga/effects';
import { REQUEST } from 'redux-config/reduxHelpers';
import {
  GET_ANNOUNCEMENTS_LIST,
  GET_ANNOUNCEMENT_DETAIL,
  CREATE_ANNOUNCEMENT,
  UPDATE_ANNOUNCEMENT,
  DELETE_ANNOUNCEMENT,
  TOGGLE_ANNOUNCEMENT,
  getAnnouncementsList,
  getAnnouncementDetail,
  createAnnouncement,
  updateAnnouncement,
  deleteAnnouncement,
  toggleAnnouncement,
} from './actions';
import {
  getAnnouncementsList as apiGetAnnouncementsList,
  getAnnouncementDetail as apiGetAnnouncementDetail,
  createAnnouncement as apiCreateAnnouncement,
  updateAnnouncement as apiUpdateAnnouncement,
  deleteAnnouncement as apiDeleteAnnouncement,
  toggleAnnouncement as apiToggleAnnouncement,
} from '../_api';

function* handleGetAnnouncementsList() {
  try {
    const { data } = yield call(apiGetAnnouncementsList);
    yield put(getAnnouncementsList.success(data));
  } catch (error) {
    yield put(getAnnouncementsList.failure(error));
  }
}

function* getAnnouncementsListWatcher() {
  while (true) {
    yield take(GET_ANNOUNCEMENTS_LIST[REQUEST]);
    yield call(handleGetAnnouncementsList);
  }
}

function* handleGetAnnouncementDetail(action) {
  try {
    const { id } = action;
    const { data } = yield call(apiGetAnnouncementDetail, id);
    yield put(getAnnouncementDetail.success(data));
  } catch (error) {
    yield put(getAnnouncementDetail.failure(error));
  }
}

function* getAnnouncementDetailWatcher() {
  while (true) {
    const payload = yield take(GET_ANNOUNCEMENT_DETAIL[REQUEST]);
    yield call(handleGetAnnouncementDetail, payload);
  }
}

function* handleCreateAnnouncement(action) {
  try {
    const { type, ...data } = action.payload || action;
    const { data: responseData } = yield call(apiCreateAnnouncement, data);
    yield put(createAnnouncement.success(responseData));
    yield call(handleGetAnnouncementsList);
  } catch (error) {
    yield put(createAnnouncement.failure(error));
  }
}

function* createAnnouncementWatcher() {
  while (true) {
    const payload = yield take(CREATE_ANNOUNCEMENT[REQUEST]);
    yield call(handleCreateAnnouncement, payload);
  }
}

function* handleUpdateAnnouncement(action) {
  try {
    const { id, data } = action;
    const { data: responseData } = yield call(apiUpdateAnnouncement, id, data);
    yield put(updateAnnouncement.success(responseData));
    yield call(handleGetAnnouncementsList);
  } catch (error) {
    yield put(updateAnnouncement.failure(error));
  }
}

function* updateAnnouncementWatcher() {
  while (true) {
    const payload = yield take(UPDATE_ANNOUNCEMENT[REQUEST]);
    yield call(handleUpdateAnnouncement, payload);
  }
}

function* handleDeleteAnnouncement(action) {
  try {
    const { id } = action;
    yield call(apiDeleteAnnouncement, id);
    yield put(deleteAnnouncement.success());
    yield call(handleGetAnnouncementsList);
  } catch (error) {
    yield put(deleteAnnouncement.failure(error));
  }
}

function* deleteAnnouncementWatcher() {
  while (true) {
    const payload = yield take(DELETE_ANNOUNCEMENT[REQUEST]);
    yield call(handleDeleteAnnouncement, payload);
  }
}

function* handleToggleAnnouncement(action) {
  try {
    const { id } = action;
    const { data } = yield call(apiToggleAnnouncement, id);
    yield put(toggleAnnouncement.success(data));
    yield call(handleGetAnnouncementsList);
  } catch (error) {
    yield put(toggleAnnouncement.failure(error));
  }
}

function* toggleAnnouncementWatcher() {
  while (true) {
    const payload = yield take(TOGGLE_ANNOUNCEMENT[REQUEST]);
    yield call(handleToggleAnnouncement, payload);
  }
}

export default [
  fork(getAnnouncementsListWatcher),
  fork(getAnnouncementDetailWatcher),
  fork(createAnnouncementWatcher),
  fork(updateAnnouncementWatcher),
  fork(deleteAnnouncementWatcher),
  fork(toggleAnnouncementWatcher),
];
